<template>
  <auth-layout pageClass="login-page">
    <div class="row d-flex justify-content-center align-items-center">
      <div class="col-lg-4 col-md-6 col-sm-8">
        <fade-render-transition>
          <card class="custom-shadow-card-header">
            <div slot="header">
              <h4 class="card-title text-center">Politicas de Contraseña</h4>
            </div>
            <div>
              <div id="rr" class="custom-control custom-switch">
                <l-switch v-model="policys.upper" color="green">
                  <i class="fa fa-check" slot="on"></i>
                  <i class="fa fa-times" slot="off"></i>
                </l-switch> Mínimo una mayúscula
              </div>
              <div class="custom-control custom-switch">
                <l-switch v-model="policys.lower" color="green">
                  <i class="fa fa-check" slot="on"></i>
                  <i class="fa fa-times" slot="off"></i>
                </l-switch> Mínimo una minúscula
              </div>
              <div class="custom-control custom-switch">
                <l-switch v-model="policys.digit" color="green">
                  <i class="fa fa-check" slot="on"></i>
                  <i class="fa fa-times" slot="off"></i>
                </l-switch> Mínimo un numero
              </div>
              <div class="custom-control custom-switch">
                <l-switch v-model="policys.lenght" color="green">
                  <i class="fa fa-check" slot="on"></i>
                  <i class="fa fa-times" slot="off"></i>
                </l-switch> Mínimo 8 caracteres 
              </div>
              <div class="custom-control custom-switch">
                <l-switch v-model="policys.special" color="green">
                  <i class="fa fa-check" slot="on"></i>
                  <i class="fa fa-times" slot="off"></i>
                </l-switch> Mínimo un carácter especial
              </div>
              <div class="custom-control custom-switch">
                <l-switch v-model="policys.same" color="green">
                  <i class="fa fa-check" slot="on"></i>
                  <i class="fa fa-times" slot="off"></i>
                </l-switch> Deben ser iguales
              </div>
            </div>
          </card>
        </fade-render-transition>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-8">
        <form method="POST" @submit.prevent="validateSubmit">
          <fade-render-transition>
            <card class="custom-shadow-card-header">
              <div slot="header">
                <h4 class="card-title text-center">Restablecer Contraseña</h4>
              </div>
              <div class="card_reset">
                <fg-input placeholder="Correo Electronico o Usuario"
                  v-model="user.login"
                  v-validate="modelValidations.login"
                  :error="getError('correo electronico o usuario')"
                  name="correo electronico o usuario"
                  v-on:keyup="validateKey"
                  type="text">
                </fg-input>
                <fg-input 
                  placeholder="Contraseña"
                  v-model="user.password"
                  v-on:keyup="validatePolicys"
                  :type="showPass.inputTypePass"
                  :myCustom="{addon : 'not-input-group-addon'}">
                  <template slot="addonRight">
                    <l-button @click="showPassword('1')"> 
                      <i :class="showPass.iconBtnPass"></i> 
                    </l-button>
                  </template>
                </fg-input>                
                <fg-input 
                  placeholder="Confirmar Contraseña"
                  v-model="user.password_confirmation"
                  v-on:keyup="validatePolicys"
                  :type="showPass.inputTypePass"
                  :myCustom="{addon : 'not-input-group-addon'}">
                  <template slot="addonRight">
                    <l-button @click="showPassword('1')"> 
                      <i :class="showPass.iconBtnPass"></i> 
                    </l-button>
                  </template>
                </fg-input>
              </div><br>
              <div class="text-center">
                <button type="submit" class="btn btn-fill btn-danger btn-wd" :disabled="btnDisabled">
                  Restablecer Contraseña
                </button>
              </div>
            </card>
          </fade-render-transition>
        </form>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-8">
        <fade-render-transition>
          <card class="custom-shadow-card-header">
            <div slot="header">
              <h4 class="card-title text-center">Otras Politicas </h4>
            </div>
            <div>
              <ul>
                <li>No debe contener tres caracteres seguidos de su nombre y apellido</li>
                <li>No debe contener tres caracteres seguidos de su usuario</li>
                <li>No debe repetir contraseñas anteriores</li>
                <li>Debe cambiar la contraseña cada 3 meses</li>
              </ul>
            </div>
          </card>
        </fade-render-transition>
      </div>
    </div>
  </auth-layout>
</template>
<script>

  import { Switch as LSwitch } from 'src/components/index'
  import mixinAuth from 'src/util/mixinAuth'
  import showSwalAlert from 'src/util/alerts'
  import axios from 'axios'

  export default {
    components: {
      LSwitch,
    },
    data () {
      return {
        // datos de usuario
        user: {
          password_confirmation: '',
          token: ''
        },
        // validar politicas pass
        policys: {
          upper: false,
          lower: false,
          digit: false,
          lenght: false,
          special: false,
          same: false,
        },
      }
    },
    mixins: [mixinAuth],
    methods: {
      // llamamos a nuestra accion passwordReset del store pasandole los datos de usuario
      passReset () {
        this.passwordReset(this.user).then((response) => {
          // si el cambio se realiza, lo enviamos al home despues despues de unos segundos
          showSwalAlert('¡Tu contraseña ha sido restablecida!', 'success')
          setTimeout( () => {
            this.$router.push('/')
          }, 3000);
        }).catch((error) => {
          showSwalAlert(error.response.data.message, 'error')
        })
      },

      validateSubmit () {
          this.$validator.validateAll().then(isValid => {
            if(isValid) {
              this.btnDisabled = false
              this.passReset()
            }
            else this.btnDisabled = true
          })
      },       

      // este metodo permite mostrar/ocultar las contraseñas
      showPassword(input_num) {
        if( input_num === '1'){
          if(this.showPass.inputTypePass === 'password') {
            this.showPass.iconBtnPass = 'fa fa-eye-slash'
            this.showPass.inputTypePass = 'text'
          } else {
            this.showPass.iconBtnPass = 'fa fa-eye'
            this.showPass.inputTypePass = 'password'
          }
        } else {
          if(this.showPass.inputTypePass2 === 'password') {
            this.showPass.iconBtnPass2 = 'fa fa-eye-slash'
            this.showPass.inputTypePass2 = 'text'
          } else {
            this.showPass.iconBtnPass2 = 'fa fa-eye'
            this.showPass.inputTypePass2 = 'password'
          }
        }
      },

      // con este metodo validamos que la contraseña escrita, cumpla con las politicas
      validatePolicys () {
        this.policys.upper   =  (/[A-Z]/.test(this.user.password)) ? true : false
        this.policys.lower   =  (/[a-z]/.test(this.user.password)) ? true : false
        this.policys.digit   =  (/[0-9]/.test(this.user.password)) ? true : false
        this.policys.lenght  =  (this.user.password.length > 7) ? true : false
        this.policys.special =  (/[.:,;<>¿¡=#@$!%\*\+\-\}\{\)\(\/|\_?&]/.test(this.user.password)) ? true : false
        this.policys.same =  (
          (this.user.password == this.user.password_confirmation) && this.user.password.length > 7
        ) ? true : false

        if (
          this.policys.upper && this.policys.lower &&
          this.policys.digit && this.policys.lenght &&
          this.policys.special && this.policys.same 
        ) this.btnDisabled = false
        else this.btnDisabled = true
      },
    },    
    // con el ciclo de vida, validamos que el token de reset exista antes de cargar la pagina
    beforeCreate () {
      axios.get( '/auth/find/' + this.$route.params.token)
        .then((response) => {
          this.user.token = response.data.data.token
        })
        .catch((error) => {
          showSwalAlert('La solicitud ha vencido, intentelo nuevamente', 'error').then(() => this.$router.push('/login'))
        })
    },
  }
</script>
<style>

li, .custom-control{
  font-size: 15px !important;
}

.custom-control div:first-child{
  margin-right: 7px !important;
}

.login-page .card {
    padding-top: initial !important;
}
  
</style>